// test1116
(1116 && 0);
